import { FC } from 'react';
import { Bull, CommonProofEC } from 'types';
import utils from 'utils';
import { objectFilter } from 'object-fn-ts';
import { Box, Stack, Typography } from '@mui/material';
import LEIndexes from '../Proof/LEIndexes';
import { Img } from 'components/common';
import TableCenterChart from '../Proof/TableCenterChart';
import GenericTableCenterChart from '../Proof/GenericTableCenterChart';

type Props = {
  bull: Bull;
  selectedProof?: any;
  selectedProofData?: any[] | any | { [key: string]: string };
  proofObject?: any;
};

/* leite europeu - component rendering */
const ELBullDetails: FC<Props> = ({
  selectedProof,
  selectedProofData,
  bull,
}) => {
  return (
    <>
      {selectedProof !== ' ' &&
        selectedProofData !== null &&
        utils.segmentFromBullOrBreed(bull) === 'el' && (
        <>
          <Stack
            {...utils.stack.flex.col('flex-start', 'center')}
            spacing={2}
            sx={utils.sx.fw}
          >
            <Typography>{selectedProof}</Typography>
          </Stack>

          <Stack
            {...utils.stack.flex.col('flex-start', 'flex-start')}
            spacing={3}
            sx={{
              width: '100%',
              maxWidth: '480px',
              overflowX: 'auto',
              overflowY: 'hidden',
            }}
          >
            <LEIndexes selectedProofData={selectedProofData} />

            <Box
              sx={{
                width: '100%',
                maxWidth: '450px',
                minWidth: '340px',
                borderRadius: '4px',
                minHeight: '100px',
                marginTop: '44px !important',
              }}
            >
              <Stack
                {...utils.stack.flex.row('flex-start', 'center')}
                spacing={4}
              >
                <Img
                  url="/icons/el-efc.svg"
                  sx={{ width: '60px', height: '60px' }}
                />
                <Typography variant="h3" sx={{ color: '#014380' }}>
                  {'EFICIÊNCIA'}
                  {(selectedProofData as CommonProofEC)?.EFICIÊNCIA?.[
                    'Eficiência'
                  ]?.value &&
                      ` +${
                        (selectedProofData as CommonProofEC).EFICIÊNCIA[
                          'Eficiência'
                        ].value
                      }`}
                </Typography>
              </Stack>

              <TableCenterChart
                selectedProofData={selectedProofData}
                color="#014380"
                objName="EFICIÊNCIA"
              />

              <Stack
                {...utils.stack.flex.row('flex-start', 'center')}
                spacing={4}
              >
                <Img
                  url="/icons/el-sau.svg"
                  sx={{ width: '60px', height: '60px' }}
                />
                <Typography variant="h3" sx={{ color: '#98002E' }}>
                  {'SAÚDE'}
                  {(selectedProofData as CommonProofEC)?.SAÚDE?.['Saúde']
                    ?.value &&
                      ` +${
                        (selectedProofData as CommonProofEC).SAÚDE['Saúde']
                          .value
                      }`}
                </Typography>
              </Stack>

              <TableCenterChart
                selectedProofData={selectedProofData}
                color="#98002E"
                objName="SAÚDE"
              />
              {Object.entries(
                objectFilter(selectedProofData || {}, (key) =>
                  [ 'CONFORMAÇÃO', 'PERFIL LINEAR', 'MANEJO/SANIDADE' ].includes(
                    key.toString()
                  )
                )
              ).map(([ title, data ]) => (
                <GenericTableCenterChart
                  data={data}
                  title={title}
                  key={title}
                />
                // <Stack>
                //   <Stack flexDirection={'row'} alignItems="center" > 
                //     <Typography variant='h3'>{ title }</Typography>
                //     {title ==='CONFORMAÇÃO' &&<Typography fontSize={12} marginLeft={1}> ACC: {data?.ACC?.value} </Typography>}
                //   </Stack>
                //   <TableCenterChart
                //     selectedProofData={selectedProofData}
                //     color="#014380"
                //     objName={title}
                //     titleValFontSize="12px !important"
                //   />
                // </Stack>
              ))}
            </Box>
          </Stack>
        </>
      )}
    </>
  );
};

export default ELBullDetails;
